const applets = [
    {
        "text": "Survey",
        "icon": "/image/application/survey.svg",
        "id": "QnrApplet",
        "path": "QnrApplet",
        "description": "Demonstrate a assessmentApplicationSurveyReducer application."
    }
]


export default applets;